module.exports = __webpack_public_path__ + "static/media/gal2010-15.70af40bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal2010/gal2010-15.jpg
// module id = 568
// module chunks = 0